// ============================================================================
// SWAHILI TRANSLATIONS - CHAPTER 2: KUTOKA
// ============================================================================
// Viwango 14-26 (viwango 13, maswali 39)

export const chapter2Translations = {
  name: "Kutoka",
  description: "Ukombozi wa watu wa Mungu... Kumjua Mungu hubadilisha maisha yetu",
  
  spiritualWisdom: {
    principle: "Maarifa ya Mungu hukomboa na kubadilisha",
    scripture: "Mtaijua kweli, na kweli itawafanya huru (Yohana 8:32)",
    application: "Kama Israeli ilivyokombolewa kutoka Misri, maarifa ya Mungu hutukomboa kutoka utumwa wa kiroho"
  },
  
  levels: {
    14: {
      name: "Musa Aliokolewa Kutoka Majini",
      challenge: "Mwanamke akapata mimba, akazaa mtoto wa kiume. Alipoona kwamba ni mzuri...",
      easy: {
        question: "Mama yake Musa alimficha mwanawe katika nini?",
        options: ["Pango", "Kikapu cha matete", "Bakuli", "Nyumba"],
        hint: "Chombo hiki kilielea juu ya Nili",
        funFact: "🏺 Kikapu cha matete kilikuwa kimepakwa lami ili kisimwagilie maji!"
      },
      medium: {
        question: "Nani alimkuta Musa katikati ya matete?",
        options: [
          "Binti Farao",
          "Mtumishi wa Kigibuti",
          "Dada yake Miriamu",
          "Kuhani wa Kigibuti"
        ],
        hint: "Mwanachama wa familia ya kifalme ya Kigibuti",
        funFact: "👑 Kwa ucheshi, familia ya Farao ndiyo inayemwokoa yule atakayemkabili!"
      },
      hard: {
        question: "Utendaji wa kimungu unavyotumia hata maadui zetu?",
        options: [
          "Kwa kuwageuza",
          "Kwa kupanga hali ili kutimiza makusudi yake",
          "Kwa kuwaadhibu",
          "Kwa kuwapuuza"
        ],
        hint: "Inahusu kuona mkono wa Mungu katika matukio",
        funFact: "✨ Musa alikua katika jumba la yule aliyeonea watu wake!"
      }
    },
    
    15: {
      name: "Kichaka Kinachowaka",
      challenge: "Malaika wa BWANA akamtokea katika mwali wa moto...",
      easy: {
        question: "Musa alipaswa kuvua nini mbele ya kichaka kinachowaka?",
        options: ["Mapambo yake", "Viatu vyake", "Joho lake", "Kilemba chake"],
        hint: "Kinachovaliwa miguuni",
        funFact: "👡 Kuvua viatu kunaonyesha heshima juu ya ardhi takatifu!"
      },
      medium: {
        question: "Jina gani Mungu anamfunulia Musa?",
        options: [
          "BWANA",
          "MIMI NI YEYE ALIYE",
          "Mwenyezi Mungu",
          "Muumbaji"
        ],
        hint: "Jina linalofafanua uwepo kamili",
        funFact: "🔥 YHWH (Mimi ni) inafunua asili ya milele ya Mungu!"
      },
      hard: {
        question: "Kichaka kinachowaka bila kuungua kinafundisha nini?",
        options: [
          "Uchawi upo",
          "Mungu anazidi sheria za asili",
          "Moto ni takatifu",
          "Mimea ina uchawi"
        ],
        hint: "Inahusu asili ya kimungu inayozidi uelewa wetu",
        funFact: "🌿 Kichaka kinasimboliza kuwa uwepo wa kimungu hutakasa bila kuharibu!"
      }
    },

    16: {
      name: "Mapigo Kumi ya Misri",
      challenge: "Farao alifanya moyo wake mgumu wala hakuwasikiliza...",
      easy: {
        question: "Nini kilikuwa pigo la kwanza la Misri?",
        options: ["Vyura", "Maji yaliyogeuzwa kuwa damu", "Nzi", "Chawa"],
        hint: "Iliathiri Nili, chanzo cha uzima kwa Misri",
        funFact: "🩸 Nili iliabudiwa kama mungu, na Mungu alionyesha ubora wake!"
      },
      medium: {
        question: "Pigo la mwisho na la kutisha zaidi lilikuwa nini?",
        options: [
          "Mvua ya mawe",
          "Giza",
          "Kifo cha wazaliwa wa kwanza",
          "Nzige"
        ],
        hint: "Pigo hili liliathiri familia moja kwa moja",
        funFact: "😢 Pigo hili hatimaye lilivunja kiburi cha Farao na kuwafungua Israeli!"
      },
      hard: {
        question: "Kwa nini Mungu anafanya moyo wa Farao kuwa mgumu?",
        options: [
          "Kumwadhibu",
          "Kuonyesha utukufu na nguvu yake",
          "Kwa uovu",
          "Kuongeza mateso"
        ],
        hint: "Inahusu kufunua ni nani Mungu wa kweli",
        funFact: "⚡ Mapigo yanaonyesha kwamba YHWH ni mwenye nguvu zaidi kuliko miungu yote ya Kigibuti!"
      }
    },

    17: {
      name: "Pasaka",
      challenge: "Chukueni mwana-kondoo... na mpake damu yake juu ya miimo...",
      easy: {
        question: "Waisraeli walipaswa kuweka damu ya mwana-kondoo wapi?",
        options: [
          "Juu ya nguo zao",
          "Juu ya miimo na milango ya nyumba",
          "Juu ya vipaji vyao vya uso",
          "Katika vikombe"
        ],
        hint: "Kwenye ingilio la nyumba zao",
        funFact: "🩸 Damu kwenye mlango ilikuwa ishara ya ulinzi wa kimungu!"
      },
      medium: {
        question: "Walipaswa kula mwana-kondoo wa Pasaka vipi?",
        options: [
          "Wakiketi kwa ustarehe",
          "Katika familia tu",
          "Viuno vikifungwa, viatu vikiwa miguuni, fimbo mkononi",
          "Kwa kimya"
        ],
        hint: "Wako tayari kuondoka",
        funFact: "🚶 Walipaswa kuwa tayari kuondoka haraka kuelekea uhuru!"
      },
      hard: {
        question: "Mwana-kondoo wa Pasaka anatanguliaje Kristo?",
        options: [
          "Kwa rangi yake nyeupe",
          "Kwa dhabihu yake mbadala inayookoa kutoka kifo",
          "Kwa upole wake",
          "Kwa umri wake"
        ],
        hint: "Inahusu dhabihu inayookoa kutoka hukumu",
        funFact: "🐑 Yesu anaitwa 'Mwana-kondoo wa Mungu anayeondoa dhambi ya ulimwengu'!"
      }
    },

    18: {
      name: "Kuvuka Bahari ya Shamu",
      challenge: "Musa akanyoosha mkono wake juu ya bahari...",
      easy: {
        question: "Waisraeli walivuka bahari vipi?",
        options: [
          "Kwa mashua",
          "Kwa kuogelea",
          "Kwa nchi kavu",
          "Kwa mtumbwi"
        ],
        hint: "Sakafu ya bahari ilikuwa ya kupitika",
        funFact: "🌊 Mungu alibadilisha kizuizi kuwa njia ya ukombozi!"
      },
      medium: {
        question: "Nini kiliwapata Wamisri waliokuwa wakiwafuatilia?",
        options: [
          "Walirudi nyuma",
          "Walimezwa na maji",
          "Walipotea",
          "Walijiunga na Israeli"
        ],
        hint: "Maji yaliwarudia",
        funFact: "⚔️ Jeshi lenye nguvu zaidi duniani liliharibiwa kwa dakika moja!"
      },
      hard: {
        question: "Kuvuka huku kunasimboliza nini katika maisha yetu ya kiroho?",
        options: [
          "Kukimbia kutoka matatizo",
          "Kuvuka kutoka utumwa wa dhambi kwenda uhuru katika Mungu",
          "Ubora wa Israeli",
          "Uharibifu wa maadui"
        ],
        hint: "Inahusu mabadiliko ya kiroho",
        funFact: "🗽 Bahari ya Shamu inawakilisha ubatizo: kifo kwa ya kale, uzima mpya!"
      }
    },

    19: {
      name: "Mana Jangwani",
      challenge: "Ni nini hiki? Kwa maana hawakujua ni nini...",
      easy: {
        question: "Mana ilianguka kwa muda gani?",
        options: ["Miaka 10", "Miaka 20", "Miaka 40", "Miaka 50"],
        hint: "Idadi sawa na miaka jangwani",
        funFact: "🍞 Kwa miaka 40, Mungu aliwalisha kwa ajabu watu milioni 2!"
      },
      medium: {
        question: "Nini kingetokea wakihifadhi mana zaidi ya siku moja?",
        options: [
          "Ingeongezeka ladha",
          "Ingezidisha",
          "Ingeoza na kunuka vibaya",
          "Ingeganda"
        ],
        hint: "Isipokuwa Ijumaa kwa ajili ya Sabato",
        funFact: "🪱 Mungu alifundisha kwa njia hii kutegemea kwake kila siku!"
      },
      hard: {
        question: "Mana inafundisha vipi kuhusu imani?",
        options: [
          "Kwa kuhifadhi kwa siku zijazo",
          "Kwa kutegemea upatikanaji wa Mungu wa kila siku",
          "Kwa kufanya kazi kwa bidii zaidi",
          "Kwa kushiriki kwa usawa"
        ],
        hint: "Inahusu kuamini siku baada ya siku",
        funFact: "🙏 'Utupe leo mkate wetu wa kila siku' inatoka kwenye uzoefu huu!"
      }
    },

    20: {
      name: "Maji kutoka Mwambani",
      challenge: "Utapiga mwamba, nayo maji yatatoka...",
      easy: {
        question: "Musa angepiga mwamba kwa nini?",
        options: ["Mkono wake", "Fimbo yake", "Jiwe", "Nyundo"],
        hint: "Chombo cha miujiza ya Musa",
        funFact: "⚡ Fimbo ya Musa ilikuwa chombo cha nguvu za Mungu!"
      },
      medium: {
        question: "Kwa nini watu walinungʼunika dhidi ya Musa?",
        options: [
          "Hakukuwa na maji ya kunywa",
          "Chakula kilikuwa kidogo",
          "Safari ilikuwa ndefu sana",
          "Kulikuwa na joto sana"
        ],
        hint: "Mahitaji muhimu jangwani",
        funFact: "💧 Maji ni muhimu zaidi kuliko chakula kwa kuishi!"
      },
      hard: {
        question: "Maji kutoka mwambani yanawakilisha nini kiroho?",
        options: [
          "Rasilimali asilia",
          "Uzima wa kiroho unaotiririka kutoka kwa Kristo, Mwamba",
          "Zawadi ya juhudi",
          "Uchawi wa Mungu"
        ],
        hint: "Paulo anasema mwamba ule ulikuwa Kristo",
        funFact: "🗿 Kristo ni Mwamba uliopigwa ambao kutoka kwake unatiririka uzima wa milele!"
      }
    },

    21: {
      name: "Mlima Sinai",
      challenge: "Mlima wote wa Sinai ulikuwa na moshi, kwa sababu Bwana alishuka juu yake...",
      easy: {
        question: "Mungu alitoa amri ngapi?",
        options: ["5", "7", "10", "12"],
        hint: "Nambari kamili na timamu",
        funFact: "📜 Amri Kumi ni msingi wa maadili ya wanadamu!"
      },
      medium: {
        question: "Amri ziliandikwa kwenye nini?",
        options: [
          "Papurasi",
          "Ukanda",
          "Vibao viwili vya mawe",
          "Shaba"
        ],
        hint: "Nyenzo imara zilizoandikwa na kidole cha Mungu",
        funFact: "✍️ Ziliandikwa na Mungu mwenyewe kuonyesha umuhimu wao wa milele!"
      },
      hard: {
        question: "Madhumuni ya amri za Mungu ni nini?",
        options: [
          "Kuadhibu wanadamu",
          "Kufunua utakatifu wa Mungu na kuongoza kwa furaha",
          "Kuunda sheria ngumu",
          "Kutenganisha mataifa"
        ],
        hint: "Ni kuhusu kufunua tabia ya Mungu na njia ya wema",
        funFact: "⚖️ Amri zinafunua upendo: upendo wa Mungu na wa jirani!"
      }
    },

    22: {
      name: "Ndama wa Dhahabu",
      challenge: "Tufanyie mungu atakayetutangulia...",
      easy: {
        question: "Aroni alifanya ndama wa dhahabu kwa nini?",
        options: [
          "Sarafu za dhahabu",
          "Herini za dhahabu za watu",
          "Vito vya thamani",
          "Dhahabu kutoka jangwani"
        ],
        hint: "Vipuli binafsi vilivyotolewa na watu",
        funFact: "👂 Watu walitoa vipuli vyao ili kuunda sanamu yao wenyewe!"
      },
      medium: {
        question: "Musa alijibu vipi alipoona ndama?",
        options: [
          "Alilia",
          "Alisali",
          "Alivunja vibao vya sheria",
          "Alikasirika tu"
        ],
        hint: "Ishara ya agano lililovunjwa",
        funFact: "💥 Kuvunja vibao kulisimbolisha agano lililovunjwa!"
      },
      hard: {
        question: "Kwa nini ibada ya sanamu ni hatari kiroho?",
        options: [
          "Ni ghali",
          "Inageuza moyo kutoka kwa Mungu wa kweli kuelekea viumbe",
          "Inagawanya familia",
          "Imekatazwa"
        ],
        hint: "Ni kuhusu kumpa kiumbe kile kinachostahili Muumba",
        funFact: "💔 Ibada ya sanamu inavunja uhusiano wa kipekee na Mungu aliye hai!"
      }
    },

    23: {
      name: "Maskani",
      challenge: "Wanifanyie patakatifu, ili niweze kukaa miongoni mwao...",
      easy: {
        question: "Hema takatifu ya Waisraeli iliitwa nini?",
        options: ["Hekalu", "Maskani", "Patakatifu", "Sanduku"],
        hint: "Jina linamaanisha 'hema ya kukutania'",
        funFact: "⛺ Maskani ilikuwa 'nyumba ya kusafiri' ya Mungu na watu wake!"
      },
      medium: {
        question: "Sanduku la Agano lilikuwa na nini?",
        options: [
          "Vito vya kuhani mkuu",
          "Vibao vya sheria, mana, fimbo ya Aroni",
          "Sarafu za dhahabu",
          "Mikono ya Torati"
        ],
        hint: "Vitu vitatu vinavyosimbolisha agano na Mungu",
        funFact: "📦 Sanduku lilikuwa na 'kumbukumbu' za uaminifu wa Mungu!"
      },
      hard: {
        question: "Maskani inawakilisha nini katika uhusiano wetu na Mungu?",
        options: [
          "Jengo la kidini",
          "Uwepo wa Mungu anayekaa kati yetu na ndani yetu",
          "Mahali pa dhabihu tu",
          "Ishara ya kitaifa"
        ],
        hint: "Ni kuhusu uwepo wa Mungu unaopatikana",
        funFact: "🏠 'Miili yenu ni hekalu la Roho Mtakatifu' kulingana na Paulo!"
      }
    },

    24: {
      name: "Kuhani Mkuu Aroni",
      challenge: "Utamweka Aroni na wanawe wakfu ili wawe makuhani wangu...",
      easy: {
        question: "Nani alikuwa kuhani mkuu wa kwanza wa Israeli?",
        options: ["Musa", "Aroni", "Yoshua", "Eleazari"],
        hint: "Ndugu wa Musa",
        funFact: "👨‍⚕️ Aroni alianzisha ukoo wa ukuhani uliodumu zaidi ya miaka 1000!"
      },
      medium: {
        question: "Kuhani mkuu alivaa nini kifuani?",
        options: [
          "Msalaba wa dhahabu",
          "Kifuko cha kifua chenye mawe ya thamani kumi na mabili",
          "Medalioni",
          "Mkufu wa dhahabu"
        ],
        hint: "Mawe kumi na mabili yanayowakilisha makabila kumi na mawili",
        funFact: "💎 Kuhani mkuu alichukua Israeli yote moyoni mwake kishirika!"
      },
      hard: {
        question: "Yesu anatimiza jukumu la Kuhani Mkuu vipi?",
        options: [
          "Kwa kuvaa mavazi matakatifu",
          "Kwa kutoa damu yake mwenyewe mara moja milele",
          "Kwa kutumika hekaluni",
          "Kwa kutoka kwa Aroni"
        ],
        hint: "Ni kuhusu dhabihu kamili na ya mwisho",
        funFact: "✝️ Yesu ni Kuhani Mkuu wa milele kulingana na utaratibu wa Melkisedeki!"
      }
    },

    25: {
      name: "Sadaka",
      challenge: "Mtu yeyote miongoni mwenu akitoa sadaka kwa Bwana...",
      easy: {
        question: "Sadaka ya kila siku katika Maskani ilikuwa nini?",
        options: [
          "Sadaka ya amani",
          "Sadaka ya kuteketezwa asubuhi na jioni",
          "Sadaka ya dhambi",
          "Sadaka ya mikate"
        ],
        hint: "Mara mbili kwa siku, asubuhi na jioni",
        funFact: "🔥 Moto kwenye madhabahu haukupaswa kuzimika kamwe!"
      },
      medium: {
        question: "Kuweka mikono juu ya mnyama kunamaanisha nini?",
        options: [
          "Baraka",
          "Kuhamisha dhambi kwa mhanga",
          "Upendo kwa mnyama",
          "Wakfu"
        ],
        hint: "Ishara ya kubadilishana",
        funFact: "🤲 Mnyama alikufa badala ya mwenye dhambi - kanuni ya kubadilishana!"
      },
      hard: {
        question: "Sadaka hizi zinatabiri kazi ya Kristo vipi?",
        options: [
          "Kwa idadi yao",
          "Kwa kubadilishana: asiye na hatia anakufa kwa ajili ya mwenye hatia",
          "Kwa gharama yao",
          "Kwa uzuri wao"
        ],
        hint: "Ni kuhusu kanuni ya asiye na hatia kuchukua nafasi ya mwenye hatia",
        funFact: "🐑 'Alitobolewa kwa ajili ya makosa yetu, akaponda kwa ajili ya uovu wetu'!"
      }
    },

    26: {
      name: "Kwenye Mpaka wa Nchi ya Ahadi",
      challenge: "Nitatuma malaika mbele yako, naye atawafukuza Wakanaani...",
      easy: {
        question: "Wapelelezi wangapi walitumwa kuipeleleza Nchi ya Ahadi?",
        options: ["10", "12", "20", "40"],
        hint: "Mmoja kutoka kila kabila la Israeli",
        funFact: "🕵️ Wapelelezi 2 tu kati ya 12 walitoa ripoti ya kuhamasisha!"
      },
      medium: {
        question: "Wapelelezi gani walihamasisha watu kuingia nchini?",
        options: [
          "Aroni na Musa",
          "Yoshua na Kalebu",
          "Gadi na Asheri",
          "Reubeni na Simeoni"
        ],
        hint: "Watu wawili wenye imani walioona ahadi za Mungu",
        funFact: "🦁 Yoshua na Kalebu walikuwa pekee wa kizazi chao kuingia Kanaani!"
      },
      hard: {
        question: "Kwa nini Israeli walitanga-tanga miaka 40 jangwani?",
        options: [
          "Ili kuwaadhibu",
          "Kwa sababu ya kutokuamini ahadi za Mungu",
          "Ili kuwafundisha vita",
          "Ili kupata njia sahihi"
        ],
        hint: "Ni kuhusu ukosefu wa kumwamini Mungu",
        funFact: "🏜️ Kizazi kizima kilipaswa kufa kwa sababu ya kutokuamini!"
      }
    }
  }
};

export default chapter2Translations;
